
/**
 * Class representing a permissions object.
 * Used to store and manage basic permissions.
 */
export default class permissions {
    /**
     * Creates an instance of permissions with default values.
     */
    constructor() {
        this.home = {

            viewPage: true
        };
        this.trackShipment = {
            actions: {
                search: false,
            },
            viewPage: true
        };
        this.newShipment = {
            actions: {
                NA: { create: false, label: "" },
                TA: { create: false, label: "" },
                QT: { create: false, label: "" },
                QN: { create: false, label: "" },
                TR: { create: false, label: "" },
                NR: { create: false, label: "" },
                CT: { create: false, label: "" }
            },
            viewPage: false
        };
        this.contacts = {
            actions: {},
            viewPage: false
        };
         this.loadingList = {
            actions: {},
            viewPage: false
        };
        this.damages = {
            actions: {},
            viewPage: false
        };
        this.damageReport = {
            actions: { create: false },
            viewPage: false
        };
        this.returnableContainer = {
            actions: {},
            viewPage: false,
            tab1: false,
            tab2: false,
            tab3: false,
            tab4: false,
        };
        this.ticket = {
            actions: {},
            viewPage: false
        };
        this.reporting = {
            actions: {},
            viewPage: false
        };
        this.dashboard = {
            actions: {},
            viewPage: false
        };
        this.userProfile = {
            actions: {
                changePassword: false,
                installPrinter: false
            },
        };
    }
}
